import logga from "../../../Assets/logga497.png";
import { logAndNotifyError, logDebugSilently } from "../../../modules/logger";
import { useNavigate, useParams } from "react-router-dom";
import { get, post } from "../../../modules/server";
import Notify from "devextreme/ui/notify";

import { RoundStatus, RoundStep, useRound } from "../../../modules/roundHandler";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button, Card, Table } from "react-bootstrap";
import { useState } from "react";
import { ModuleTypeId } from "../../../types/DBTables";
import { IModuleByggnadsdata } from "../../../types/ModuleDatas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faFilePdf, faSave } from "@fortawesome/free-solid-svg-icons";
import StickyBreadCrumb from "../../Global/StickyBreadCrumb";
import { Colors } from "../../../modules/Colors";
import { useGlobalData } from "../../GlobalDataProvider";
import { showPDFFromBase64 } from "../../../modules/common";

const RoundStepReport = () => {
  const [theStep, setTheStep] = useState(undefined as undefined | RoundStep);

  const [showConfirm, setShowConfirm] = useState(false);
  const [draftsToBeDeleted, setDraftsToBeDeleted] = useState([] as any[]);
  const [finishVariant, setFinishVariant] = useState("" as string | undefined);
  const [isSaving, setIsSaving] = useState(false);

  if (theStep?.stepType || !theStep?.data?.modules?.length) {
    const dbg = 4;
  }

  logDebugSilently("Render RoundPageStep:" + new Date());

  // const { buildingIndex , stepIndex }  = useParams();
  //New construction that let us read the number value from the params
  const params = useParams();
  const globalData = useGlobalData();
  let roundId: string | number | undefined = params.roundId;
  let stepIndex: string | number | undefined = params.stepIndex;
  const user = globalData.user;

  const round = useRound();
  const navigate = useNavigate();

  roundId = parseInt(roundId === undefined ? "0" : roundId);
  const roundVM = round.getRoundViewModelFromId(roundId);

  const dtString = new Date(roundVM?.date).toLocaleDateString("sv-SE");
  const [theDate, setTheDate] = useState(dtString);

  if (!roundId || !stepIndex || !roundVM) return <></>;

  const building = round.getBuilding(roundVM?.buildingId as number);
  const buildingModules = roundVM.getModules((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
  const buildingData = buildingModules.length ? (buildingModules[0].data as IModuleByggnadsdata | undefined) : undefined;
  const roundSummary = round.getRoundSummary(roundVM);
  const numberFormatter = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 });

  stepIndex = parseInt(stepIndex);

  const onPreFinish = async (variant?: any) => {
    try {
      const buildingId = roundVM?.buildingId;
      setIsSaving(true);
      const res = await get("GetBuildingRounds/" + buildingId);
      const anyDraftRoundExceptThisOne = (res?.rounds || []).filter((r: any) => r.status === RoundStatus.Draft && r.id !== roundId);
      if (anyDraftRoundExceptThisOne.length) {
        setIsSaving(false);
        setShowConfirm(true);
        setDraftsToBeDeleted(anyDraftRoundExceptThisOne);
        setFinishVariant(variant);
      } else {
        onFinish(variant);
      }
    } catch (err: any) {
      setIsSaving(false);
      logDebugSilently("Error saving round: " + err.toString());
      logAndNotifyError("Kunde inte spara ronderingen");
    }
  };
  const onFinish = async (variant?: any) => {
    try {
      setIsSaving(true);
      const theRound = round.getFinishedRound();
      if (theRound) {
        theRound.status = RoundStatus.Finished;
        const byggnadsInformation = { ...buildingData, ByggnadsNamn: building?.name };
        const prms = {
          round: theRound,
          summaryData: { ...roundSummary, byggnadsInformation: byggnadsInformation, isSommar: theRound.isSummer, datum: new Date(theRound.date).toLocaleDateString("sv-SE") },
          removeDrafts: variant === "letDraftsBe" ? false : true,
        };
        if (variant === "copy") {
          //Copy to the date
          const roundCopy = { ...theRound };
          roundCopy.date = new Date(theDate);
          prms.summaryData.datum = theDate;
          roundCopy.id = 0;
          prms.round = roundCopy;
        }
        const res = await post("SaveFinishedRound", prms);
        setIsSaving(false);
        if (res?.succeeded) {
          round.updateLastRoundLocally(res.round);
          const buildingId = round.getFinishedRound()?.buildingId as number;

          navigate("/Buildings/" + buildingId);
          Notify("Ändringarna har sparats", "success");
          showPDFFromBase64(res.pdf);
        } else {
          Notify(res?.message, "error");
        }
      }
    } catch (err: any) {
      setIsSaving(false);
      logDebugSilently("Error saving round: " + err.toString());
      logAndNotifyError("Kunde inte spara ronderingen");
    }
  };

  const showPDF = async () => {
    const res = await post("GetPDFReport", { roundId: roundId });
    if (res?.succeeded) {
      showPDFFromBase64(res.pdf);
    } else {
      Notify(res?.message, "error");
    }
  };

  round.getRoundStep(roundId, stepIndex).then((retStep) => {
    if (retStep !== theStep) {
      setTheStep(retStep);
    }
  });

  const visaÅtgärdadITable1 = roundSummary.tables.funktionsfel.filter((fk) => fk.KanÅtgärdas).length > 0;
  const visaÅtgärdadITable3 = roundSummary.tables.funktionsKontroller.filter((fk) => fk.KanÅtgärdas).length > 0;
  const visaÅtgärdadITable4 = roundSummary.tables.funktionsKontrollerSEK.filter((fk) => fk.KanÅtgärdas).length > 0;

  return (
    <>
      {roundVM.status === RoundStatus.Draft && showConfirm && (
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Alla utkast för denna byggnad kommmer att tas bort!</h4>
          <p>Det finns {draftsToBeDeleted.length} ronderingar som inte är avslutade. Dessa kommer att tas bort!. Vill du fortsätta?</p>
          <hr />

          {isSaving ? (
            <div className="m-3 ms-5">
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              <span>Sparar...</span>
            </div>
          ) : (
            <>
              <Button variant="danger" disabled={isSaving} onClick={() => setShowConfirm(false)} className="mb-2">
                Avbryt
              </Button>
              <Button variant={globalData.isOnline ? "success" : "warning"} disabled={isSaving || !globalData.isOnline} onClick={() => onFinish(finishVariant)} className="ms-2 mb-2">
                {globalData.isOnline ? `Spara och avsluta (Och ta bort ${draftsToBeDeleted.length} utkast)` : `Spara och avsluta (offline)`}
              </Button>
              {user?.roles.Admin && globalData.isOnline && (
                <Button variant="success" disabled={isSaving} onClick={() => onFinish("letDraftsBe")} className="ms-2 mb-2">
                  Spara och avsluta (Låt utkast vara kvar, endast Admin)
                </Button>
              )}
            </>
          )}
        </div>
      )}
      <StickyBreadCrumb items={round.getBreadCrumbItems(params)}>
        {roundVM.status === RoundStatus.Draft ? (
          !showConfirm && (
            <Button className="" variant={globalData.isOnline ? "success" : "warning"} disabled={isSaving || !globalData.isOnline} onClick={onPreFinish}>
              {isSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span>Sparar...</span>
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSave} />
                  <span className="ps-2">{globalData.isOnline ? "Spara och avsluta" : "Spara och avsluta (offline)"}</span>
                </>
              )}
            </Button>
          )
        ) : (
          <Button className="" variant="success" onClick={showPDF}>
            <FontAwesomeIcon icon={faFilePdf} />
            <span className="ps-2">Visa PDF-rapporten</span>
          </Button>
        )}
        {globalData.isDebug && roundVM.status === RoundStatus.Finished && (
          <>
            {/* <Button variant="success" onClick={onTestPDF}>
              <FontAwesomeIcon icon={faFilePdf} />
              <span className="ps-2">Test PDF</span>
            </Button> */}
            <hr />
            <Button variant="success" onClick={onFinish} style={{ width: "100%" }} className="mt-2">
              <FontAwesomeIcon icon={faSave} />
              <span className="ps-2">Spara igen (skapa ny PDF + underlag till Dashboard)</span>
            </Button>
            <hr />
            <div style={{ minWidth: 140 }}>
              <div className="input-group mt-2">
                <div className="form-control">
                  <input type="text" placeholder="Spara nytt datum" onChange={(e) => setTheDate(e.target.value)} value={theDate} style={{ width: "100%" }} />
                </div>
              </div>

              <Button variant="success" onClick={() => onFinish("copy")}>
                <FontAwesomeIcon icon={faCopy} />
                <span className="ps-2">Spara kopia som ny rondering på angivet datum</span>
              </Button>
            </div>
          </>
        )}
      </StickyBreadCrumb>

      <Card className="mt-5 mb-5">
        <Card.Header>{"Du är nu klar med ronderingen av byggnad  " + building?.name}</Card.Header>
        <Card.Body>Klicka på "Spara och avsluta" för att klarmarkera och avsluta ronderingen</Card.Body>
      </Card>

      <div id="roundReport" style={{ maxHeight: 400 }}>
        {roundVM ? (
          <>
            <div>
              <img src={logga} alt="logga" height="67px" />{" "}
              <h3 style={{ display: "inline", verticalAlign: "middle", whiteSpace: "nowrap" }}>
                Ronderingsrapport - {roundVM.isSummer ? "Sommar" : "Vinter"} {new Date(roundVM.date).toLocaleDateString("sv-SE")}
              </h3>
            </div>

            <div style={{ marginBottom: 20 }} />
            {buildingData ? (
              <>
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: 120 }}>Byggnad</td>
                      <th>{building?.name}</th>
                    </tr>
                    <tr>
                      <td style={{ width: 120 }}>Område</td>
                      <th>{buildingData.område}</th>
                    </tr>
                    <tr>
                      <td>Gatuadress</td>
                      <th>{buildingData.adress}</th>
                    </tr>
                    <tr>
                      <td>Postnummer</td>
                      <th>{buildingData.postnummer}</th>
                    </tr>
                    <tr>
                      <td>Ort</td>
                      <th>{buildingData.ort}</th>
                    </tr>
                  </tbody>
                </Table>
                <div style={{ marginBottom: 20 }} />
              </>
            ) : (
              <></>
            )}
            <div style={{ marginBottom: 30 }} />
            <h2>Summering rondering</h2>
            <Table bordered hover>
              <tbody>
                <tr>
                  <th>Totalt insparad energi</th>
                  <th style={{ textAlign: "right", width: 200 }}>{numberFormatter.format(roundSummary.summary.energySaved)} kWh/år</th>
                </tr>
                <tr>
                  <th>Potentiell energi att spara</th>
                  <th style={{ textAlign: "right", width: 200 }}>{numberFormatter.format(roundSummary.summary.potentialEnergyToSave)} kWh/år</th>
                </tr>
                {roundSummary.summary.potentialSekToSave > 0 && (
                  <tr>
                    <th>Potentiell kostnad att spara (SEK)</th>
                    <th style={{ textAlign: "right", width: 200 }}>{numberFormatter.format(roundSummary.summary.potentialSekToSave)} kr/år</th>
                  </tr>
                )}
                {roundSummary.summary.sekSaved > 0 && (
                  <tr>
                    <th>Insparad kostnad (SEK)</th>
                    <th style={{ textAlign: "right", width: 200 }}>{numberFormatter.format(roundSummary.summary.sekSaved)} kr/år</th>
                  </tr>
                )}
              </tbody>
            </Table>

            {roundSummary.tables.funktionsfel.length ? (
              <>
                <div style={{ marginBottom: 30 }} />
                <h2>1.0 Status funktionskontroller</h2>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th style={{ width: 50 }}>Pkt</th>
                      <th style={{ width: 150 }}>System</th>
                      <th style={{ textAlign: "right", width: 150 }}>kWh/år</th>

                      <th style={{ width: 180 }}>Energislag</th>
                      <th>Meddelande</th>
                      {visaÅtgärdadITable1 && <th style={{ width: 50 }}>Åtgärdad</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {roundSummary.tables.funktionsfel.map((fkf, ffIndex) => (
                      <tr key={ffIndex}>
                        <td>1.{ffIndex + 1}</td>
                        <td>{fkf.system}</td>
                        <td style={{ textAlign: "right" }}>{fkf.kWhs !== undefined && !Number.isNaN(fkf.kWhs) ? numberFormatter.format(fkf.kWhs as number) : ""}</td>
                        <td>{fkf.energiSlag}</td>
                        <td>{fkf.message}</td>
                        {visaÅtgärdadITable1 && (
                          <td style={{ textAlign: "center" }}>
                            {fkf.KanÅtgärdas && <input type="checkbox" disabled={true} checked={fkf.Åtgärdad} className="form-check-input" />}
                            {/* {fkf.Åtgärdad ? <> JA </> : <></>}
                          {!fkf.Åtgärdad && typeof fkf.kWhs === "number" ? <> NEJ </> : <></>} */}
                          </td>
                        )}
                      </tr>
                    ))}
                    <tr key="sum">
                      <th colSpan={2} style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        Summa
                      </th>
                      <th style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        {" "}
                        {numberFormatter.format(roundSummary.summary.funktionsFelEnergySaved + roundSummary.summary.funktionsFelPotentialEnergyToSave) + " kWh/år"}
                      </th>
                      <th colSpan={3}></th>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <></>
            )}
            <div style={{ breakAfter: "page" }}></div>
            {roundSummary.tables.driftoptimeringar.length ? (
              <>
                <div style={{ marginBottom: 30 }} />
                <h2>2.0 Status driftoptimeringar</h2>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th style={{ width: 50 }}>Pkt</th>
                      <th style={{ width: 150 }}>System</th>
                      <th style={{ textAlign: "right", width: 150 }}>kWh/år</th>
                      <th style={{ width: 180 }}>Energislag</th>
                      <th>Meddelande</th>
                      {/* todo : remove */}
                      {globalData.isDebug && <th style={{ width: 50 }}>Åtgärdad</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {roundSummary.tables.driftoptimeringar.map((optimering, optIndex) => (
                      <tr key={optIndex} style={{ color: optimering.inverteraTecken ? Colors.RedMedium : Colors.GrayBlack }}>
                        <td>2.{optIndex + 1}</td>
                        <td>{optimering.system}</td>
                        <td style={{ textAlign: "right" }}>{optimering.kWhs !== undefined && !Number.isNaN(optimering.kWhs) ? numberFormatter.format(optimering.kWhs as number) : ""}</td>
                        <td>{optimering.energiSlag}</td>
                        <td>{optimering.message}</td>

                        {globalData.isDebug && (
                          <td style={{ textAlign: "center" }}>
                            <input type="checkbox" disabled={true} checked={optimering.Åtgärdad} className="form-check-input" />
                            {/* {optimering.Åtgärdad ? <> JA </> : <></>}
                            {!optimering.Åtgärdad && typeof optimering.kWhs === "number" ? <> NEJ </> : <></>} */}
                          </td>
                        )}
                      </tr>
                    ))}
                    <tr key="sum">
                      <th colSpan={2} style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        Summa
                      </th>
                      <th style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        {" "}
                        {numberFormatter.format(roundSummary.summary.driftOptimeringarEnergySaved + roundSummary.summary.driftOptimeringarPotentialEnergyToSave) + " kWh/år"}
                      </th>
                      <th colSpan={3}></th>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <></>
            )}

            {roundSummary.tables.funktionsKontroller.length ? (
              <>
                <div style={{ marginBottom: 30 }} />
                <h2>3.0 Funktionsmeddelanden</h2>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th style={{ width: 50 }}>Pkt</th>
                      <th style={{ width: 150 }}>System</th>

                      <th>Meddelande</th>
                      {visaÅtgärdadITable3 && <th style={{ width: 50 }}>Åtgärdad</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {roundSummary.tables.funktionsKontroller.map((fk, fkIndex) => (
                      <tr key={fkIndex}>
                        <td>3.{fkIndex + 1}</td>
                        <td>{fk.system}</td>

                        <td>{fk.message}</td>

                        {visaÅtgärdadITable3 && (
                          <td style={{ textAlign: "center" }}>{fk.KanÅtgärdas && <input type="checkbox" disabled={true} checked={fk.Åtgärdad} className="form-check-input" />}</td>
                        )}
                        {/* <td>{fk.Åtgärdad ? "X" : "-"}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ) : (
              <></>
            )}

            {roundSummary.tables.funktionsKontrollerSEK?.length ? (
              <>
                <h2>4.0 Funktionsmeddelanden fjärrvärmeväxlare</h2>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th style={{ width: 150 }}>Pkt</th>
                      <th style={{ width: 150 }}>System</th>
                      <th style={{ textAlign: "right", width: 150 }}>SEK/år</th>
                      <th>Meddelande</th>
                      <th style={{ width: 50 }}>Åtgärdad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roundSummary.tables.funktionsKontrollerSEK.map((fk, fkIndex) => (
                      <tr key={fkIndex}>
                        <td>4.{fkIndex + 1}</td>
                        <td>{fk.system}</td>
                        <td style={{ textAlign: "right" }}>{fk.sek !== undefined && !Number.isNaN(fk.sek) ? numberFormatter.format(fk.sek as number) : ""}</td>
                        <td>{fk.message}</td>
                        <td style={{ textAlign: "center" }}>
                          <input type="checkbox" disabled={true} checked={fk.Åtgärdad} className="form-check-input" />
                          {/* {fk.Åtgärdad ? <> JA </> : <></>}
                          {!fk.Åtgärdad && typeof fk.sek === "number" ? <> NEJ </> : <></>} */}
                        </td>
                      </tr>
                    ))}
                    <tr key="sum">
                      <th colSpan={2} style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        Summa
                      </th>
                      <th style={{ textAlign: "right", backgroundColor: "lightgray" }}>
                        {" "}
                        {numberFormatter.format(roundSummary.summary.sekSaved + roundSummary.summary.potentialSekToSave) + " SEK/år"}
                      </th>
                      <th colSpan={3}></th>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
      <div style={{ marginBottom: 500 }} />
    </>
  );
};

export default RoundStepReport;
